export default __webpack_public_path__ + "static/media/close-icon-dark.da49f387.svg";